import axios from "axios";

export const beWhereApi = axios.create({
  baseURL: `https://api.bewhere.com/accounts/${process.env.REACT_APP_BEWHERE_ACCOUNT_ID}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json', 
    'Token': process.env.REACT_APP_BEWHERE_API_KEY
  }
});
